import React, { useContext, useState } from 'react';
import { LanguageContext } from '../context/LanguageContext';
import { content } from '../data/content';

const Header = () => {
  const { language, toggleLanguage } = useContext(LanguageContext);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  
  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };
  
  return (
    <header className="fixed w-full bg-white shadow-md z-50">
      <div className="container mx-auto px-4 py-3 flex justify-between items-center">
        <div className="flex items-center">
          <img src="/images/logo.png" alt="Sumou Sam Logo" className="h-12 mr-3" />
         
        </div>
        
        <nav className="hidden md:block">
          <ul className="flex space-x-6">
            {Object.entries(content[language].navigation).map(([key, value]) => (
              <li key={key}>
                <a href={`#${key}`} className="text-gray-700 hover:text-blue-600 transition-colors">
                  {value}
                </a>
              </li>
            ))}
          </ul>
        </nav>
        
        <div className="flex items-center space-x-4">
          <button 
            onClick={toggleLanguage}
            className="px-4 py-1 bg-blue-600 text-white rounded-full hover:bg-blue-700 transition-colors"
          >
            {language === 'en' ? 'العربية' : 'English'}
          </button>
          <button 
            className="md:hidden focus:outline-none" 
            onClick={toggleMobileMenu}
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        </div>
      </div>
      
      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="md:hidden bg-white border-t border-gray-200">
          <ul className="py-2">
            {Object.entries(content[language].navigation).map(([key, value]) => (
              <li key={key}>
                <a 
                  href={`#${key}`} 
                  className="block px-4 py-2 text-gray-700 hover:bg-gray-100"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  {value}
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}
    </header>
  );
};

export default Header;